/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import * as Text from "@/components/text";
import Metadata from "./Metadata";
import Button from "../actions/Button";
import classNames from "classnames";
import PropTypes from "prop-types";

const themes = {
  light: "bg-white text-neutral-900",
  dark: "bg-neutral-900 text-white",
};

const sizes = {
  xl: "w-[305px]",
  lg: "w-[232px]",
  md: "w-[189px]",
  sm: "w-[152px]",
};

function PosterCard({
  size = "lg",
  film_image = "https://images.unsplash.com/photo-1658686873732-c93680078088?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1287&q=80",
  film_metadata,
  film_link = "",
  film_synopsis = "",
  theme = "dark",
  film_name = "",
  film_trailer_link = "",
  film_streaming_link = "",
  film_original_title = "",
  film_directors = [],
  grid_details = false,
  slug = "",
}) {
  const [visible, toggleVisible] = useState(false);
  return (
    <div className={classNames("w-full", "aspect-[3/2]")}>
      {/* On hover it toggles the visible state, which controls the zoom and the overlay */}
      <motion.div
        onMouseEnter={() => toggleVisible(true)}
        onMouseLeave={() => toggleVisible(false)}
        className="relative overflow-hidden bg-black"
      >
        {/* This is the poster card image, it zooms in on hover, visible state controls the zoom */}
        <Link href={slug} passHref>
          <motion.img
            alt="movie poster"
            className={`${"relative aspect-[3/2] h-full w-full cursor-pointer object-cover transition duration-500"} ${
              visible ? "scale-125" : "scale-100"
            }`}
            src={film_image}
          ></motion.img>
        </Link>

        {/* Overlay should only show on desktop */}
        <motion.div
          animate={{ opacity: visible ? 1 : 0 }}
          className="absolute top-0 h-full w-full bg-neutral-1000/[.64] text-white sm:hidden lg:block "
        >
          <div className="flex h-full w-full items-center justify-center">
            <div className="pointer w-3/4 space-y-4 p-4">
              {/* <div
                  className="text-[0.875rem] leading-[1.25rem] tracking-[-0.008rem]"
                  dangerouslySetInnerHTML={{ __html: film_synopsis }}
                ></div> */}

              {/* {film_metadata ? (
                  <div className="">
                    <Metadata
                      theme="dark"
                      size="sm"
                      film_metadata={film_metadata}
                    />
                  </div>
                ) : null} */}

              <div className=" flex w-full flex-col gap-2 ">
                {film_streaming_link ? (
                  <Link
                    href={film_streaming_link}
                    target="_blank"
                    className="z-50 w-full"
                  >
                    <Button
                      size="sm"
                      color="secondary-dark"
                      className=" w-full"
                      label="Ver película"
                      trailingIcon={
                        <img
                          className="ml-2 h-3 w-3"
                          src="/next_assets/img/film/play_icon.png"
                          alt="thumbnail"
                        ></img>
                      }
                    ></Button>
                  </Link>
                ) : film_trailer_link ? (
                  <Link
                    href={film_trailer_link}
                    target="_blank"
                    className="z-50 w-full"
                  >
                    <Button
                      size="sm"
                      color="secondary-dark"
                      className=" w-full"
                      label="Ver trailer"
                      trailingIcon={
                        <img
                          className="ml-2 h-3 w-3"
                          src="/next_assets/img/film/play_icon.png"
                          alt="thumbnail"
                        ></img>
                      }
                    ></Button>
                  </Link>
                ) : null}
                <Link className="" href={slug} passHref rel="noreferrer">
                  <Button
                    size="sm"
                    color="terciary-dark"
                    className="w-full max-w-full"
                    label="Ver detalles"
                  ></Button>
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>

      {/* Movie title */}
      {grid_details && (
        <div
          className={classNames(
            themes[theme],
            `${
              grid_details ? "grid-rows-[0.3fr_0.2fr_0.1fr_0.1fr] " : ""
            } md: grid grid-cols-1 space-y-2 px-1 py-2 `
          )}
        >
          <div className="">
            <Text.ProperNoun
              className={`mr-2  gap-2 sm:text-[16px] lg:text-[20px] ${
                theme === "light" ? "text-neutral-800" : "text-neutral-100"
              } normal-case`}
              fontWeight="bold"
              as="span"
              size="md"
            >
              {film_name}
            </Text.ProperNoun>
          </div>

          <div>
            {film_original_title ? (
              <Text.Noun
                className={`${
                  theme === "light" ? "text-neutral-700" : "text-neutral-500"
                } font-semibold normal-case`}
                as="span"
                size="lg"
              >
                ({film_original_title})
              </Text.Noun>
            ) : null}
          </div>

          {/* Movie directors */}
          <Text.Body
            as="div"
            className={`${
              theme === "light" ? "text-neutral-800" : "text-neutral-500"
            } last:after:content-[''] sm:text-[14px] lg:text-[16px]`}
            size="sm"
          >
            {film_directors.map((director, i) => (
              <span className=" pr-2" key={i}>
                {director} {i === film_directors.length - 1 ? null : ","}
              </span>
            ))}
          </Text.Body>
          {size != "sm" ? (
            film_metadata ? (
              <Metadata theme="light" size="sm" film_metadata={film_metadata} />
            ) : null
          ) : null}
        </div>
      )}
    </div>
  );
}

PosterCard.propTypes = {
  film_trailer_link: PropTypes.string,
  film_synopsis: PropTypes.string,
  film_streaming_link: PropTypes.string,
  film_ama: PropTypes.bool,
  theme: PropTypes.oneOf(["light", "dark"]),
  film_name: PropTypes.string,
  film_original_title: PropTypes.string,
  film_directors: PropTypes.array,
};

export default PosterCard;
